module.exports = __webpack_public_path__ + "img/mirakl-logo.67328edb.png";